// extracted by mini-css-extract-plugin
export var description = "AaaPricingPanel-module__description___Bgvxf";
export var option = "AaaPricingPanel-module__option___RJ-vx";
export var optionMargin = "AaaPricingPanel-module__optionMargin___ksY7d";
export var optionsGroups = "AaaPricingPanel-module__optionsGroups___kQN6Z";
export var verticallyAligned = "AaaPricingPanel-module__verticallyAligned___0n1W9";